import { render, staticRenderFns } from "./iconUrl.vue?vue&type=template&id=5a99c322&scoped=true"
import script from "./iconUrl.vue?vue&type=script&lang=js"
export * from "./iconUrl.vue?vue&type=script&lang=js"
import style0 from "./iconUrl.vue?vue&type=style&index=0&id=5a99c322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a99c322",
  null
  
)

export default component.exports